exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inbox-entry[data-v-5ac2aac2]{cursor:pointer;font-size:.9em}.inbox-entry[data-v-5ac2aac2]:hover{background:rgba(0,0,0,.1)}.inbox-entry.router-link-exact-active[data-v-5ac2aac2]{background:rgba(0,0,0,.05)}.badge-container[data-v-5ac2aac2]{min-width:2.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ac2aac2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/received-files-view/received-files-sidebar-entry.vue
// module id = 99
// module chunks = 0